import React from 'react'
import { withTranslation as translate } from 'react-i18next'

class findingBookingAccessibleAccommodation extends React.Component{
    
  render(){
    return(
      <div className="container finding-booking-accessible-accommodation">
        <h1>How does it work to use Handiscover?</h1>
        <p>
        We have over 100 000 hotels and  accommodations all around the World, that we assess for their accessibility. You can enjoy a great vacation adapted your needs and bring along one of your travel companions, be it friends or family.
We gather both fully accessible accommodations and hotels rooms, but also regular rooms that your friends, family or assistants can book too at the same time.

        </p>
        <p>
            You are of course welcome to use Handiscover and enjoy our great prices and customer service even if 
            you do not have any special needs! You can read more about us and our team 
          <a href={`${HOST_URL}/${this.props.state.locale}/about/`} target='blank'>&nbsp;here.</a>
        </p>
        <h2>Handiscover in a nutshell</h2>
        <p>
            Like on any booking website, you can <strong>search</strong> for multiple destinations, <strong>find</strong>  accommodations and <strong>book</strong> 
            them in one go, either on your desktop or mobile. But unlike any other website,
            we provide very detailed information about accessibility, at room level and you get
            the chance to book that specific room, knowing that Handiscover has validated (link to validated icon)
            the accessibility and will follow up with the host to ensure that you <strong>really get that room.</strong><br/> 
          <strong>That is Our commitment.</strong> 
        </p>
        <p>
          <i>
            Handiscover is all about preventing you from facing some of the horror stories that we have been facing over the years prior to Handiscover, when trying to book accessible accommodations or rooms on generic websites just to come to the hotel and not being able to enter the hotel due to stairs or finding that the accessible room had already been given to another guest!!
          </i>
        </p>
        <p>
            Also, get inspiration for your travel using our extensive content with blog articles,
             travel guides and travel tips here.
          <a href={`/${this.props.state.locale}/content/`} target="blank">&nbsp;here.</a>
        </p>
        <h2>Finding and booking an accessible accommodation</h2>
        <h3>To find and identify an Accessible Accommodation:</h3>
        <span>Please find below a little written guide and an instructional video</span>
        <div className="row guide-section">
          <div className="col-md">
            <ul className="finding-booking-accessible-accommodation-list">
              <li>1. Go to <a href="" target="blank">handiscover.com</a></li>
              <li>2. Enter where you want to go.</li>
              <li>3. Choose how mobile you are by selecting on of the icons</li>
              <li>4. Pick a date.</li>
              <li>5. Enter number of guests</li>
              <li>6. Click the “Find a Place” button.</li>
              <li>7. A comprehensive list of classified accommodations that fit your mobility needs in your dream destination is ready for you. You can use filters or use the map to zoom in or out. You can also move around the map, to upload properties in a more specific area.</li>
            </ul>
          </div>
          <div className="col-md">
            <div className="finding-booking-accessible-accommodation-image-wrapper">
              <img src={require('../images/home-page/home-page-search.png')} alt="home page icon guide" className="finding-booking-accessible-accommodation-image"/>
            </div>
          </div>
        </div>
        <div className="row  guide-section">
          <div className="col">
            <span>For example, if you enter London and choose Fully Accessible, then you will see a list like below.</span>
          </div>
          <div className="col">
            <div className="finding-booking-accessible-accommodation-image-wrapper">
              <img src={require('../images/home-page/london-search.png')} alt="london search" className="finding-booking-accessible-accommodation-image"/>
            </div>
          </div>
        </div>
        <div className="row  guide-section">
          <div className="col-md">
            <span>8. Choose a property/hotel:</span>
            <p>
            From only one more click on property pictures, you can see the detailed accessibility features of each accommodation, without having a need to do an extensive research or make numerous phone calls to the hosts by yourself. This will leave you more time to plan your itinerary and pack your luggage!
            </p>
          </div>
          <div className="col-md">
            <div className="finding-booking-accessible-accommodation-image-wrapper">
              <img src={require('../images/home-page/hotel-guide.png')} alt="hotel guide" className="finding-booking-accessible-accommodation-image"/>
            </div>
          </div>
        </div>
        <div className="row  guide-section">
          <div className="col-md">
            <p>
            9. Choose the rates that fit you the best (for hotels) and book directly using Book Now to secure the price you see now or Booking Enquiry if you wish to enquire without commitment. Note though that prices can change during the enquiry process.
            You can also contact the hotel or host using the Contact Message /Contact Hotel green button if you have specific questions.
             You will then be able to follow the conversation through our Inmail system that you reach from the Dashboard when you are logged in to your account.
            </p>
          </div>
          <div className="col-md">
            <div className="finding-booking-accessible-accommodation-image-wrapper">
              <img src={require('../images/home-page/rates-guide.png')} alt="rates guide" className="finding-booking-accessible-accommodation-image"/>
            </div>
          </div>
        </div>
        <div className="row  guide-section">
          <div className="col-md">
            <h3>Similar accessible properties in the Area</h3>
            <p>
            When you find a nice accommodation or hotel that suit your needs, 
            you can also easily find others by scrolling to the bottom of the 
            Object Page. Below the property description or rates (for hotels) 
            you will find <strong>“Similar properties/hotels to stay in the area”</strong>  that 
            we can recommend based on your early choices including Property type 
            (Apartment or Hotel for example), accessibility level, price range etc.
            </p>
          </div>
          <div className="col-md">
            <div className="finding-booking-accessible-accommodation-image-wrapper">
              <img src={require('../images/home-page/similar-guide.png')} alt="similar guide" className="finding-booking-accessible-accommodation-image"/>
            </div>
          </div>
        </div>
        <div className="row  guide-section">
          <div className="col">
            <h3>Instructional video on how to find and book accessible accommodations on Handiscover</h3>
            <p>
            This video is based on a Desktop user. The process is the same on a Tablet or Mobile but the look of the screen will obviously vary a little bit!
            </p>
            <p>
            Come back to us to share what you think about it!
            </p>
            <iframe src="https://www.youtube.com/embed/yfgXZlVPBY8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <p>
            Through Handiscover, you are guaranteed the availability and accessibility of the place you book and our customer service is always there to help you.
            </p>
            <p>
            Your payments are safely held by our payment provider before being transferred to your Host, 24h after check-in. This lets you travel in peace, knowing your money will not be paid out ot the Hots until you have arrived and are happy with the accessibility of the accommodation.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default findingBookingAccessibleAccommodation
